import React from 'react'
import { ReactComponent as Flows } from '../../assets/ic_inspections.svg';
import '../../theme/overrides/ative.css';
import '../../theme/overrides/inative.css';

const InspectionsIcon = (state) => (
    <Flows className={state ? 'ative' : 'inative'} />
);

export default InspectionsIcon;